export default "__VITE_ASSET__Bmk_ZoZi__"